import { withStyles } from '@material-ui/core';

import { AvatarCellFactory as InnerAvatarCellFactory } from './AvatarCell';
import { avatarCellStyles } from './avatarCellStyles';

export const AvatarCellFactory = (employeeIdField: string, employeeNameField: string) => {
    return withStyles(avatarCellStyles)(InnerAvatarCellFactory(employeeIdField, employeeNameField));
};
